import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M21 20.25h-7m10-4.504l-5.5.004"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M21 20.25h-7m10-4.504l-5.5.004"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M42 40.5H28m20-9.008L37 31.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.69 25.704l6.703-11.514-5.33 13.108c-.576 1.412-1.652 3.452-3.342 3.06-.94-.218-1.612-1.348-1.9-2.702-.184-.866-.23-1.786-.272-2.702.15.634.78 2.634 2.336 2.396.598-.098 1.24-.684 1.804-1.646z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M23.98 13.5c4.046 0 7.472-2.66 8.624-6.328.34-1.084 1.682-1.446 2.488-.64l7.082 7.08a4.49 4.49 0 010 6.348L21.634 40.5H8.276A3.775 3.775 0 014.5 36.724a3.779 3.779 0 012.558-3.576l5.134-1.746a5.303 5.303 0 003.412-3.646L22 3.882"
  }))
};
export var RunStroke = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});